import { render } from "./header.vue?vue&type=template&id=1263ec4d&scoped=true"
import script from "./header.vue?vue&type=script&lang=js"
export * from "./header.vue?vue&type=script&lang=js"

import "./header.vue?vue&type=style&index=0&id=1263ec4d&scoped=true&lang=css"

import exportComponent from "/var/www/kostyum-admin-front/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-1263ec4d"]])

export default __exports__